<div
  class='filters-button'
  *ngIf='hasFilters'
  [ngClass]='{ active: !filterMenuHidden, rtl: cService.selectedLanguage?.isRtl }'
  (click)='toggleFilterMenu()'
>
  <div fxLayout='row' flex style='position: relative; top: 10px' class='padding-l-20 padding-r-20'>
    <div fxLayout='row' fxFlex>
      <span fxFlex *ngIf='cService.isMobileViewport'></span>
      <div class='margin-r-25'>
        <mat-icon style='position: relative; top: 6px; right: 3px'>filter_alt</mat-icon>
        <span>{{ 'GENERIC.filter' | translate | uppercase }} ({{ filterCount }})</span>
      </div>
    </div>

    <mat-icon class='rotate-item' [class.right]='!filterMenuHidden' style='position: relative; top: 4px'>
      expand_more
    </mat-icon>
  </div>
</div>
<div
  id='filtering-menu'
  class='filter-pane'
  [ngClass]='{ rtl: cService.selectedLanguage?.isRtl }'
  *ngIf='!filterMenuHidden'
>
  <div *ngFor='let filter of dashboardFilters'>
    <div class='filter-input-container' *ngIf='filter?.transformedValues?.length > 0'>
			<span *ngIf='filter.locationName'>{{
        cService.readyTranslations.dashboardFilters[filter.locationName]
          ? cService.readyTranslations.dashboardFilters[filter.locationName]
          : (filter.locationName | titlecase)
        }}</span>
      <angular2-multiselect
        [data]='filter.transformedValues'
        [(ngModel)]='dashboardService.activeDashboardFilters[filter.location]'
        [settings]='filter.dropwDownSettings'
        [loading]='filterLoading'
        ngDefaultControl
        (onClose)='filterSelectedOrDeselected()'
        (onDeSelect)='filterSelectedOrDeselected()'
        (onDeSelectAll)='filterDeselectedAll(filter)'
      >
      </angular2-multiselect>
    </div>
  </div>
  <div *ngFor='let location of locations'>
    <div class='filter-input-container' *ngIf='location?.transformedValues?.length > 0'>
      <span *ngIf='location.locationName'>{{ location.locationName }}</span>
      <angular2-multiselect
        [data]='location.transformedValues'
        [(ngModel)]='dashboardService.activeDashboardFilters[location.location]'
        [settings]='locationDropdownSettings'
        [loading]='filterLoading'
        ngDefaultControl
        (onClose)='filterSelectedOrDeselected()'
        (onDeSelect)='filterSelectedOrDeselected()'
        (onDeSelectAll)='filterSelectedOrDeselected()'
      >
      </angular2-multiselect>
    </div>
  </div>
  <div class='padding-25' fxLayout='row' fxLayoutAlign='space-between'>
    <button type='button' mat-raised-button (click)='applyFilter()' class='bold'>
      {{ 'GENERIC.applyFilters' | translate }}
    </button>

    <button
      type='button'
      mat-raised-button
      color='warn'
      class='reset bold'
      [disabled]='!filterCount'
      (click)='resetFilter()'
    >
      {{ 'AGGRIDLOCALE.resetFilter' | translate }}
    </button>
  </div>
</div>
